module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/components/ClanSupplyFooter/images/footer_bg_get_rewards_large.47a7addf.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/components/ClanSupplyFooter/images/footer_bg_get_rewards_large.png
// module id = 2938
// module chunks = 11